module.exports = __webpack_public_path__ + "img/airlink.7e3e2e90.svg";